/**
 * @generated SignedSource<<e9df834a57ee6f9a6e1d6a70f7a5cea8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type helpObjectChannel_HelpObjectStoreChannel$data = {
  readonly description: string | null | undefined;
  readonly displayLink: string | null | undefined;
  readonly title: string | null | undefined;
  readonly " $fragmentType": "helpObjectChannel_HelpObjectStoreChannel";
};
export type helpObjectChannel_HelpObjectStoreChannel$key = {
  readonly " $data"?: helpObjectChannel_HelpObjectStoreChannel$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpObjectChannel_HelpObjectStoreChannel">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "helpObjectChannel_HelpObjectStoreChannel",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "title"
    },
    {
      "kind": "ScalarField",
      "name": "description"
    },
    {
      "kind": "ScalarField",
      "name": "displayLink"
    }
  ],
  "type": "HelpObjectStoreChannel"
};

(node as any).hash = "f82f63c0afc3b2033ea8e2783eb773f1";

export default node;
